<template>
  <section class="main-box">
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters" ref="param">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="按考试名称搜索"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSearch()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--列表-->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="examName" label="考试名称" align="center">
        </el-table-column>
        <el-table-column prop="examBeginTime" label="开考时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="examEndTime" label="结束时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="examAllFen" label="试卷总分" align="center">
        </el-table-column>
        <el-table-column prop="userFen" label="我的成绩(分)" align="center" :formatter="formatFen">
        </el-table-column>
        <el-table-column prop="status" label="考试状态" align="center" :formatter="formatStatus">
        </el-table-column>
        <!--        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="formatDate">-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="openDetails(scope.$index, scope.row,1)" v-if="scope.row.userFen==null">开始考试</el-button>
            <el-button size="small" @click="openDetails(scope.$index, scope.row,9)"v-if="scope.row.userFen!=null">查看成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 详情界面 -->
    <el-dialog :title="formData.examName+'----试卷总分:'+formData.examAllFen+'分'" :width="width" :visible.sync="detailsVisible" :modal="false" class="details" :close-on-click-modal="false">
      <div v-if="detailsVisible">
        <ExamView :form-data="formData" :qu-data="quData" @doSubmit="doSubmit" @doCancel="doCancel" :type="viewType" :answer-data="userAnswer" :exam-value="answer.examAllFen"></ExamView>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import { examDel, examSearch, examDetail,examStatus,examQues,proSearch,userExamMes} from '../../api/api'
  import ExamForm from "./ExamForm";
  import ExamView from "./ExamView";
  import ProjectList from "../command/ProjectList";

  export default {
    components: {ProjectList, ExamView, ExamForm},
    data() {
      return {
        proId:null,
        filters: {},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        loading: false,
        total: 2,
        page: 1,
        limit: 15,
        data: [],
        formData: {},
        formVisible: false,
        detailId: null,
        option:0,
        detailsVisible: false,
        width:'90%',
        quData:[],
        proList:[],
        viewType:1,
        userAnswer:[],
        answer:{}
      }
    },
    methods: {
      //查询
      searchData: function () {
        // this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.select, this);
        this.loading = true;
        this.filters.page = this.page;
        this.filters.limit = this.limit;//请求参数
        if (this.filters.searchTab == '') {
          this.filters.searchTab = null;
        }
        this.filters.proId = this.proId == '' ? null : this.proId;
        this.filters.comId = this.GLOBAL.user.comId;
        this.filters.status = 1;
        this.filters.userId = this.GLOBAL.user.id;
        examSearch(this.filters, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });
      },
      doSearch: function () {
        this.searchData()
      },
      resetForm: function () {
        this.filters = {}
      },
      searchPage: function (val) {
        this.page = val;
        this.searchData();
      },
      formatDate: function (row, column) {
        if(column.property == 'examBeginTime')
          return this.GLOBAL.formatTimeToStr(row.examBeginTime, "yyyy-MM-dd hh:mm:ss");
        if(column.property == 'examEndTime')
          return this.GLOBAL.formatTimeToStr(row.examEndTime, "yyyy-MM-dd hh:mm:ss");
        if(column.property == 'createTime')
          return this.GLOBAL.formatTimeToStr(row.createTime, "yyyy-MM-dd hh:mm:ss");
      },
      formatStatus: function (row, column) {
        return row.status == 0 ? '未开考' :  '开考';
      },
      formatFen:function(row,column){
        if(row.userFen==null){
          return 0;
        }
        else {
          return row.userFen;
        }
      },
      //========================================
      //添加视图
      showAddView: function () {
        let res = true;
        if (res) {
          this.option = 0;
          this.formData = {}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView: function (index, row) {
        let res = true;
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          examDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
        this.detailsVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
        this.detailsVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = true;
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            examDel({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //查看详情
      openDetails: function (index, row,viewType) {
        let res = true;
        if (res) {
          examDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              if(this.formData!=null){
                //获取试卷
                examQues({quNo:this.formData.examQuestion}, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.quData = result.data;
                    // console.log(this.quData)
                    this.viewType = viewType;
                    //获取当前用户作答情况
                    if(viewType ==9){
                      userExamMes({examId:row.id,userId:this.GLOBAL.user.id}, this.GLOBAL.header).then(result => {
                        if (result.success) {
                          this.answer = result.data;

                          this.userAnswer = JSON.parse(this.answer.examAnswer);

                          this.detailsVisible = true;
                        }
                      });
                    }
                    this.detailsVisible = true;
                  }
                });
              }
              this.detailsVisible = true;
            }
          });

        }
      },
      changeStatus:function(index, row,s){
        let res = true;
        if (res) {
          let p = {};
          p.id = row.id;
          p.status = s;
          examStatus(p, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.searchData();
            }
          });
        }
      },
      proChange:function(proId){
        this.proId = proId;
        this.doSearch();
      }
    },
    mounted() {
    }
  };
</script>
<style scoped>
  .download {
    text-decoration: none;
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamOnline.vue